<div
  role="rowgroup"
  class="container"
  am-layout-container
  [ngStyle]="{ gridTemplateRows: gridTemplateRows }"
>
  <div class="ga-header" data-testid="header" [ngClass]="headerEl?.parentClass">
    <ng-content select="[am-layout-header]"></ng-content>
  </div>
  <div class="ga-main" data-testid="main" [ngClass]="mainEl?.parentClass">
    <ng-content select="[am-layout-main]"></ng-content>
  </div>
  <div class="ga-footer" data-testid="footer" [ngClass]="footerEl?.parentClass">
    <ng-content select="[am-layout-footer]"></ng-content>
  </div>
</div>
